export const Co2EmissionConstants={
    D2BQ:"D2BQ",
    D2BM:"D2BM",
    CO2_EMISSION:"CO2_EMISSION",
    E_CO2_EMISSION_REPORT_DROPDOWN:"E_CO2_EMISSION_REPORT_DROPDOWN",
    E_CO2_EMISSION_REPORT_MONTHLY:"E_CO2_EMISSION_REPORT_MONTHLY",
    E_CO2_EMISSION_REPORT_QUARTERLY:"E_CO2_EMISSION_REPORT_QUARTERLY"
  }